module.exports = __webpack_public_path__ + "img/emily.dc99a249.jpg";